// extracted by mini-css-extract-plugin
export var fadeInOut = "_34-3";
export var icon = "_34-4";
export var savedIndicator = "_34-2";
export var savingIndicator = "_34-0";
export var spin = "_34-1";